import { fetchGroup } from 'api/Group/actions'
import { ChannelSummary } from 'ChannelSummary'
import { selectGroupData, selectRequestParams } from 'data/selectors'
import { GroupDetails } from 'GroupDetails'
import React, { memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectLastReFetchTime } from 'store/reducers/lastReFetchTime'
import { emptyObject } from 'utils'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  root: {
    '& .MuiAccordionDetails-root': {
      borderBottomLeftRadius: '0.7rem',
      borderBottomRightRadius: '0.7rem',
    },
  },
})

function GroupSummary() {
  const dispatch = useDispatch()
  const requestParams = useSelector(selectRequestParams)
  const lastReFetchTime = useSelector(selectLastReFetchTime)
  const { data, isLoading } = useSelector(selectGroupData(emptyObject))
  const classes = useStyles()
  const { t: translate } = useTranslation()

  useEffect(() => {
    dispatch(fetchGroup(requestParams))
  }, [dispatch, lastReFetchTime, requestParams])

  return (
    <ChannelSummary className={classes.root} data={data} isLoading={isLoading} label={translate('menu.title')} type="group">
      <GroupDetails data={data} isLoading={isLoading} type="group" />
    </ChannelSummary>
  )
}

export default memo(GroupSummary)
